var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_wrapR"},[_c('button',{staticClass:"comm_btn_gridTop",attrs:{"type":"button"},on:{"click":_vm.onOpenColumnSelect}},[_vm._v("\n    columns\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }